<template>
  <v-card
    height="600px"
  >
    <v-text-field
      v-model="term"
      :label="$t('Search products by name or SKU')"
      class="search-field"
      prepend-inner-icon="search"
      solo
      dark
      single-line
      background-color="primary"
      color="white"
      clearable
      @input="handleSearch"
    />

    <v-card-text
      style="height:550px"
    >
      <v-layout>
        <v-flex>
          <v-list
            two-line
            subheader
            dense
          >
            <template
              v-for="item in items"
            >
              <SearchListItem
                :key="item.id"
                :item="item"
                @selected="select(item)"
              />
            </template>

          </v-list>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        flat
        small
        @click="$emit('cancelled')"
      >
        {{ $t('Cancel') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import debounce from 'lodash.debounce'
import SearchListItem from './Items/SearchListItem'
import CountIncrement from '../../../components/CountIncrement'

export default {
  name: 'SearchItem',

  components: {
    CountIncrement,
    SearchListItem
  },

  props: {
    order: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      selectedItem: null,
      term: '',
      items: [],
      handleSearch: null
    }
  },

  created () {
    this.handleSearch = debounce(this.search, 700)
  },

  async mounted () {
    this.items = await this.$http.product
      .include(['children'])
      .orderBy('-created_at').limit(-1)
      .where('inventory.is_bundle_exclusive', 'neq', 'true')
      .get()
  },

  methods: {
    select (item) {
      let selected = { ...item }
      selected.quantity = 1
      selected.notes = []
      selected.product_id = item.id
      delete selected.id

      this.$emit('product-selected', selected)
      this.searchDialog = false
    },

    async search (term) {
      if (!term) {
        this.items = await this.$http.product.include(['children']).orderBy('-created_at').limit(40).get()
        return
      }
      this.items = await this.$http.product
        .include(['children'])
        .where('name', 'like', term)
        .where('sku', 'like', term)
        .orderBy('-created_at')
        .get()
    }
  }
}
</script>
